export enum SpecialOfferType {
    FixedPrice,
    FixedReduction,
    PercentageDiscount
}


// WEBPACK FOOTER //
// ./src/app/models/SpecialOfferType.ts